import React from 'react';
import { T, sx } from '../../lib/tokens';
import { Check } from './Icons';

type ReceiptStatus = 'pending' | 'parsed' | 'confirmed' | 'posted' | 'failed' | 'duplicate';

interface StatusBadgeProps {
  status: ReceiptStatus;
  style?: React.CSSProperties;
}

interface BadgeConfig {
  bg: string;
  color: string;
  label: string;
  icon: 'check' | 'dot';
}

const statusMap: Record<ReceiptStatus, BadgeConfig> = {
  posted: {
    bg: T.sage,
    color: T.navy,
    label: 'Reconciled',
    icon: 'check',
  },
  parsed: {
    bg: T.warnBg,
    color: T.warn,
    label: 'Review',
    icon: 'dot',
  },
  confirmed: {
    bg: T.warnBg,
    color: T.warn,
    label: 'Confirmed',
    icon: 'dot',
  },
  pending: {
    bg: T.paper2,
    color: T.graphiteDim,
    label: 'Pending',
    icon: 'dot',
  },
  duplicate: {
    bg: T.warnBg,
    color: T.warn,
    label: 'Duplicate',
    icon: 'dot',
  },
  failed: {
    bg: T.failBg,
    color: T.fail,
    label: 'Failed',
    icon: 'dot',
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, style }) => {
  const config = statusMap[status] ?? statusMap.pending;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 10px 3px 8px',
        borderRadius: 100,
        fontSize: 12,
        fontWeight: 500,
        fontFamily: "'Geist', sans-serif",
        background: config.bg,
        color: config.color,
        ...sx.mono,
        letterSpacing: '0.02em',
        ...style,
      }}
    >
      {config.icon === 'check' ? (
        <Check size={13} color={config.color} />
      ) : (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: config.color,
            flexShrink: 0,
          }}
        />
      )}
      {config.label}
    </span>
  );
};
